import script from "./ClientCabinetSignTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetSignTab.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetSignTab.vue?vue&type=style&index=0&id=1815e388&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1815e388"]])

export default __exports__